import { render, staticRenderFns } from "./start_end_page.vue?vue&type=template&id=0253ab12&scoped=true&"
import script from "./start_end_page.vue?vue&type=script&lang=js&"
export * from "./start_end_page.vue?vue&type=script&lang=js&"
import style0 from "./start_end_page.vue?vue&type=style&index=0&id=0253ab12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0253ab12",
  null
  
)

export default component.exports